import { render, staticRenderFns } from "./rm-request-responder.vue?vue&type=template&id=4b4474d4&scoped=true"
import script from "./rm-request-responder.vue?vue&type=script&lang=ts"
export * from "./rm-request-responder.vue?vue&type=script&lang=ts"
import style0 from "./rm-request-responder.vue?vue&type=style&index=0&id=4b4474d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4474d4",
  null
  
)

export default component.exports